import React from "react";
import { Link } from "react-router-dom"
import Stepper from "../../../Components/Stepper/Stepper";
import BrandLogo from "../../../Components/BrandLogo/BrandLogo";

export default function WelcomeScreen(props) {
  const clickHandler = () => {
    props.onNext();
  };

  return (
    <div className="welcomeScreen bgContainer">
      <div className="blurOverlay">
        <BrandLogo />
        <h3 className="onboardingHeading">خوش آمدید</h3>
        <h6 className="onboardingMessage">
          در کنار ما انگیزه و قدرت خود را پیدا کنید
        </h6>
        <Stepper step={props.step} />
        <button className="mainBtn" onClick={clickHandler}>
          ادامه
        </button>
        <Link to="/loginOrRegister" className="startApp link">شروع برنامه</Link>
      </div>
    </div>
  );
}
